import { useEffect, useRef, useCallback } from 'react';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { List } from 'foundations-components/transitional/components/List';
import { getId } from 'find-and-filter-data/views-schema/public';
import { useLocalStorage } from '../../../local-storage/hooks/useLocalStorage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const viewHasId = id => view => getId(view) === id;
const MORE_LINKS_ACCORDION_STATE = 'MORE_LINKS_ACCORDION_STATE';
const OPEN = 'OPEN';
const CLOSED = 'CLOSED';
const MoreLinksAccordion = ({
  currentViewId,
  views,
  viewRenderer
}) => {
  const previousViewId = useRef(currentViewId);
  const [moreLinksAccordionState, setMoreLinksAccordionState] = useLocalStorage({
    key: MORE_LINKS_ACCORDION_STATE,
    initialValue: views.some(viewHasId(currentViewId)) ? OPEN : CLOSED
  });
  const isOpen = moreLinksAccordionState === OPEN;
  const toggleHeader = useCallback(() => setMoreLinksAccordionState(moreLinksAccordionState === OPEN ? CLOSED : OPEN), [moreLinksAccordionState, setMoreLinksAccordionState]);
  useEffect(() => {
    if (!isOpen && previousViewId.current !== currentViewId && views.some(viewHasId(currentViewId))) {
      setMoreLinksAccordionState(OPEN);
    }
  }, [currentViewId, isOpen, previousViewId, views, setMoreLinksAccordionState]);
  useEffect(() => {
    previousViewId.current = currentViewId;
  }, [currentViewId]);
  return /*#__PURE__*/_jsx(AccordionItem, {
    contentStyles: {
      marginInlineStart: '-700'
    },
    "data-test-id": "more-views-dropdown-button",
    onOpenChange: toggleHeader,
    open: isOpen,
    paddingBlockStart: "200",
    paddingInlineStart: "200",
    title: isOpen ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "svh-workspace-ui-lib.navigation-sidebar.seeLessViewsToggle"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "svh-workspace-ui-lib.navigation-sidebar.seeMoreViewsToggle"
    }),
    children: /*#__PURE__*/_jsx(List, {
      "data-test-id": "more-views-list",
      wrapChildren: true,
      children: views.map(viewRenderer)
    })
  });
};
MoreLinksAccordion.displayName = 'MoreLinksAccordion';
export default MoreLinksAccordion;